import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"download\"><style>#download .st0{stroke-width:13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}</style><path class=\"st0\" d=\"M299.1 294.1H100.9M200 230.8V105.9M156.7 187.5l43.3 43.3 43.3-43.3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol